// react package
import React from "react";
import { createBrowserRouter, Navigate  } from "react-router-dom";

// pages
import Dashboard from "../pages/dashboard";

// user
import User from "../pages/user";

// patient lookup
import PatientLookup from "../pages/patient-lookup";
import PatientLookupDetails from "../pages/patient-lookup/patient-lookup-details";

// notes
import ErrorNotes from "../pages/notes";
import ErrorNotesDetail from "../pages/notes/notes-detail";

// auth
import GoogleAuth from "../pages/google";
import Login from "../pages/login";
import ForgotPasswordSet from "../pages/login/ForgotPasswordSet";

// protected
import ProtectedRoute from "../protectedroute";
import Layout from "../container/layout";
import ForgotPassword from "../pages/login/ForgotPassword";
import Maintenance from "../pages/maintenance";

// account settings
import AccountSettings from "../pages/accountsettings/accountsettings";
// import ProfileSettings from '../pages/accountsettings/accountsettings';
import RoleSettings from "../pages/accountsettings/rolesettings";
import PasswordChange from "../pages/accountsettings/passwordchange";
import ProfileSettings from "../pages/accountsettings/profilesettings";
// import ProgressNotes from "../pages/progress-notes";
import EditorContainer from "../pages/progress-notes/Editmain";

import NoteType from "../pages/progress-notes/NoteType"
import NotFound from "../pages/notfound";

// ai notes
import NotesUpload from "../pages/ai/notes/notes-upload";
import PatientNotes from "../pages/ai/patient-notes/patient-notes";

// mapping
import LocationMapping from "../pages/mapping/location/location";
import PatientMapping from "../pages/mapping/patient/patient";
import EfaxMapping from "../pages/mapping/efax/efax";

// error notes
// location error
import EmptyLocationError from "../pages/error-notes/location/empty-location-error";
import LocationError from "../pages/error-notes/location/location-error";
import MultipleLocation from "../pages/error-notes/location/multiple-location";
// patient error
import PatientNotFound from "../pages/error-notes/patient/patient-not-found";
import IncompletePatientInfo from "../pages/error-notes/patient/incomplete_patient_info";
import InformationMismatchAndMissing from "../pages/error-notes/information_mismatch_and_missing";
import NoHeaderError from "../pages/error-notes/source/no_header";
import Fax from "../pages/error-notes/fax_error";
import VirtualFAx from "../pages/error-notes/virtual_efax_error";
import Api from "../pages/error-notes/api_error";
import InvalidNotes from "../pages/error-notes/invalid_notes";
import PatientFoundMultiple from "../pages/error-notes/patient/patient-found-multiple";
import RemovedNotesList from "../pages/notes/removed_notes";
import SourceMismatch from "../pages/error-notes/source/source_mismatch";
import DosMismatch from "../pages/error-notes/source/dos_mismatch";
import AutoDelete from "../pages/auto-delete";

// icon
import { MdDashboard } from "react-icons/md";
import { LuUsers } from "react-icons/lu";
import { LuUserRoundSearch } from "react-icons/lu";
import { ImFileExcel } from "react-icons/im";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { BiUserPin } from "react-icons/bi";
import { GiKeyLock } from "react-icons/gi";
import { LiaNotesMedicalSolid } from "react-icons/lia";
import { TbCirclesRelation } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { HiOutlineSparkles } from "react-icons/hi2";
import { FiSettings } from "react-icons/fi";




export const accountSettingsRoutes = [
  {
    path: "/account-settings",
    element: <Navigate to="/account-settings/profile-settings" replace />, 
  },
  {
    path: "profile-settings",
    element: <ProfileSettings />,
    Name: "Profile Settings",
    protected: false,
    icon: BiUserPin,
    route: "/account-settings/profile-settings",

  },
  {
    path: "role-settings",
    element: (
      <ProtectedRoute requiredAccess="Role and Access" asCheckOnly >
        <RoleSettings />
      </ProtectedRoute>
    ),
    requiredAccess: "Role and Access",
    protected: true,
    Name: "Role Settings",
    icon: IoShieldCheckmarkOutline
  },
  {
    path: "change-password",
    element: <PasswordChange />,
    Name: "Security Settings",
    protected: false,
    icon: GiKeyLock
  }
];


const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute requiredAccess="Dashboard">
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/",
        element: <Navigate to="/account-settings/profile-settings" replace />,  
      },
      {
        path: "/progress-notes",
        element: (
          <ProtectedRoute requiredAccess="Dashboard">
            {/* <ProgressNotes />
             */}
            <EditorContainer />
          </ProtectedRoute>
        ),
      },
      {
        path: "/account-settings",
        element: <AccountSettings />,
        children:accountSettingsRoutes, 
        route: "/account-settings/profile-settings",
      },
      {
        path: "/users",
        element: (
          <ProtectedRoute requiredAccess="Users">
            <User />
          </ProtectedRoute>
        ),
      },
      {
        path: "/patient-lookup",
        element: (
          <ProtectedRoute requiredAccess="Patient Lookup">
            <PatientLookup />
          </ProtectedRoute>
        ),
      },
      {
        path: "/notes",
        element: (
          <ProtectedRoute requiredAccess="All Notes">
            <ErrorNotes />
          </ProtectedRoute>
        ),
      },
      {
        path: "/deleted-notes",
        element: (
          <ProtectedRoute requiredAccess="Deleted Notes">
            <RemovedNotesList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues",
        element: <Navigate to="/notes" replace />,
      },
      {
        path: "/error-queues/location-mismatch",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <LocationError />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/no-location",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <EmptyLocationError />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/duplicate-patient",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <MultipleLocation /> 
            {/* this actually mutiple patients dos */}
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/patient-not-found",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <PatientNotFound />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/information-missing",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <InformationMismatchAndMissing />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/no-header",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <NoHeaderError />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/dos-mismatch",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <DosMismatch />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/source-mismatch",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <SourceMismatch />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/inbound-efax",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <Fax />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/api-error",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <Api />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/outbound-efax",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <VirtualFAx />
          </ProtectedRoute>
        ),
      },
      {
        path: "/error-queues/parsing-error",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <InvalidNotes />
          </ProtectedRoute>
        ),
      },
      {
        path: "/notes/:id",
        element: (
          <ProtectedRoute requiredAccess="">
            <ErrorNotesDetail />
          </ProtectedRoute>
        ),
      },
      {
        path: "/mapping",
        element: <Navigate to="/mapping/location-mapping" replace />,
      },
      {
        path: "/mapping/location-mapping",
        element: (
          <ProtectedRoute requiredAccess="Mapping">
            <LocationMapping />
          </ProtectedRoute>
        ),
      },
      {
        path: "/mapping/patient-mapping",
        element: (
          <ProtectedRoute requiredAccess="Mapping">
            <PatientMapping />
          </ProtectedRoute>
        ),
      },
      {
        path: "/mapping/efax-number",
        element: (
          <ProtectedRoute requiredAccess="Mapping">
            <EfaxMapping />
          </ProtectedRoute>
        ),
      },
      {
        path: "/location-mapping",
        element: (
          <ProtectedRoute requiredAccess="Error Queues">
            <LocationMapping />
          </ProtectedRoute>
        ),
      },
 
      {
        path: "/ai",
        element: <Navigate to="/ai/notes-upload" replace />,
      },
      {
        path: "/ai/notes-upload",
        element: (
          <ProtectedRoute requiredAccess="AI">
            <NotesUpload />
          </ProtectedRoute>
        ),
      },
      {
        path: "/ai/patient-notes",
        element: (
          <ProtectedRoute requiredAccess="AI">
            <PatientNotes />
          </ProtectedRoute>
        ),
      },
      {
        path: "/s",
        element: (
          // <ProtectedRoute requiredAccess="Mapping Notes Type">
          <NoteType />
          // </ProtectedRoute>
        ),
      },
      {
        path: "/configuration",
        element: <Navigate to="/configuration/auto-delete" replace />,
      },
      {
        path: "/configuration/auto-delete",
        element: (
          <ProtectedRoute requiredAccess="Auto Delete">
            <AutoDelete />
          </ProtectedRoute>
        ),
      },
      {
        path: "/forbidden",
        element: <h6>Access Denied</h6>,
      },
      {
        path: "/patient-lookup/:id",
        element: (
          <ProtectedRoute requiredAccess="Patient Lookup">
            <PatientLookupDetails />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/google-auth",
    element: <GoogleAuth />, // Add the GoogleAuth component here
  },
  {
    path: "/forgot-password-set",
    element: <ForgotPasswordSet />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "*",
    element: <NotFound/>,
  },
  {
    path: "/maintenance",
    element: <Maintenance />
  },
]);

const Routes = [
  {
    name: "Dashboard",
    route: "/dashboard",
    icon: <MdDashboard size={20} className="text-black" />, // Example icon
  },
  {
    name: "Users",
    route: "/users",
    icon: <LuUsers  size={20} className="text-black" />, // Example icon
  },
  {
    name: "Patient Lookup",
    route: "/patient-lookup",
    icon: <LuUserRoundSearch size={20} className="text-black" />, // Example icon
  },
  {
    name: "Error Queues",
    route: "/error-queues", 
    icon: <ImFileExcel size={20} className="text-black" />,
    subMenu: [
      { name: "No Location", route: "/error-queues/no-location" },
      { name: "Duplicate Patient", route: "/error-queues/duplicate-patient" },
      { name: "No Header", route: "/error-queues/no-header" },
      { name: "Info Missing", route: "/error-queues/information-missing" },
      { name: "Inbound eFax", route: "/error-queues/inbound-efax" },
       {name : "Outbound eFax", route:"/error-queues/outbound-efax"},
      { name: "API Error", route: "/error-queues/api-error" },
      { name: "Parsing Error", route: "/error-queues/parsing-error" },
    ]
  },
  {
    name: "Mapping",
    route: "/mapping", 
    icon: <TbCirclesRelation size={20} className="text-black" />,
    subMenu: [
      { name: "Location ID", route: "/mapping/location-mapping" },
      { name: "Patient ID", route: "/mapping/patient-mapping" },
      { name: "eFax Number", route: "/mapping/efax-number" },
    ]
  },
  {
    name: "All Notes",
    route: "/notes",
    icon: <LiaNotesMedicalSolid size={20} className="text-black" />, // Example icon
  },
  {
    name: "Deleted Notes",
    route: "/deleted-notes",
    icon: <RiDeleteBin6Line size={20} className="text-black" />, // Example icon
  },
  {
    name: "Configuration",
    route: "/configuration",
    requiredAccess: "Auto Delete",
    icon: <FiSettings size={20} className="text-black" />,
    subMenu: [{ name: "Auto Delete", route: "/configuration/auto-delete"}],
  },
  {
    name: "AI",
    route: "/ai",
    icon: <HiOutlineSparkles size={20} className="text-black" />, // Example icon
    subMenu: [
      { name: "Notes Upload", route: "/ai/notes-upload" },
      { name: "Patient Notes", route: "/ai/patient-notes" },
    ]
  }
  
];

export { Routes, router };